"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateFinalNegotiationDto = void 0;
const tslib_1 = require("tslib");
const swagger_1 = require("@nestjs/swagger");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const create_insurer_participants_dto_1 = require("./create-insurer-participants.dto");
const common_1 = require("@nestjs/common");
const create_final_negotiation_participants_dto_1 = require("./create-final-negotiation-participants.dto");
class CreateFinalNegotiationDto {
    constructor(meetingDate, startTime, endTime, heldAt, minutesOfMeeting, policyPlacedTypeLid, finalisedQuoteId, participants, onlyLeadPaysCommissionLid, leadInsurerId, wouldChangeQuoteValuesLid, otherComments, variations, serviceLevelAgreementDaysLid, documentId, insurerShares) {
        this.meetingDate = meetingDate;
        this.startTime = startTime;
        this.endTime = endTime;
        this.heldAt = heldAt;
        this.minutesOfMeeting = minutesOfMeeting;
        this.policyPlacedTypeLid = policyPlacedTypeLid;
        this.finalisedQuoteId = finalisedQuoteId;
        this.participants = participants;
        this.leadInsurerId = leadInsurerId;
        this.onlyLeadPaysCommissionLid = onlyLeadPaysCommissionLid;
        this.wouldChangeQuoteValuesLid = wouldChangeQuoteValuesLid;
        this.otherComments = otherComments;
        this.variations = variations;
        this.serviceLevelAgreementDaysLid = serviceLevelAgreementDaysLid;
        this.documentId = documentId;
        this.insurerShares = insurerShares;
    }
}
exports.CreateFinalNegotiationDto = CreateFinalNegotiationDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "2024-09-10",
        description: "Meeting date must be <= today",
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "Meeting date is required" }),
    (0, class_validator_1.IsDateString)({}, { message: "Meeting date must be a valid date string" }),
    (0, class_validator_1.Matches)(/^\d{4}-\d{2}-\d{2}$/, {
        message: "Meeting Date must be in the format YYYY-MM-DD.",
    }),
    (0, class_transformer_1.Transform)(({ value }) => {
        const date = new Date(value);
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Reset time to start of the day
        if (date >= today) {
            throw new common_1.BadRequestException("The meeting date cannot be today or a future date. Please provide a valid past date.");
        }
        return value;
    }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], CreateFinalNegotiationDto.prototype, "meetingDate", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "2024-09-10T09:00:00Z", description: "Start time" }),
    (0, class_validator_1.IsNotEmpty)({ message: "Start time is required" }),
    (0, class_validator_1.IsDateString)({}, { message: "Start time must be a valid date string" }),
    (0, class_transformer_1.Transform)(({ value, obj }) => {
        obj.startTimeTemp = value;
        return value;
    }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], CreateFinalNegotiationDto.prototype, "startTime", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "2024-09-10T10:30:00Z", description: "End time" }),
    (0, class_validator_1.IsNotEmpty)({ message: "End time is required" }),
    (0, class_validator_1.IsDateString)({}, { message: "End time must be a valid date string" }),
    (0, class_transformer_1.Transform)(({ value, obj }) => {
        const start = new Date(obj.startTimeTemp);
        const end = new Date(value);
        if (start && end && end <= start) {
            throw new common_1.BadRequestException("End time must be after start time");
        }
        return value;
    }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], CreateFinalNegotiationDto.prototype, "endTime", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "Conference Room A",
        description: "Where the meeting was held",
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "Meeting location is required" }),
    (0, class_validator_1.IsString)({ message: "Meeting location must be a string" }),
    (0, class_validator_1.MinLength)(10, {
        message: "Meeting location must be at least 10 characters long",
    }),
    (0, class_validator_1.MaxLength)(100, {
        message: "Meeting location must be at most 100 characters long",
    }),
    tslib_1.__metadata("design:type", String)
], CreateFinalNegotiationDto.prototype, "heldAt", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "Discussed policy terms.",
        description: "Minutes of meeting",
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "Minutes of meeting is required" }),
    (0, class_validator_1.IsString)({ message: "Minutes of meeting must be a string" }),
    (0, class_validator_1.MinLength)(10, {
        message: "Minutes of meeting must be at least 10 characters long",
    }),
    (0, class_validator_1.MaxLength)(1000, {
        message: "Minutes of meeting must be at most 1000 characters long",
    }),
    tslib_1.__metadata("design:type", String)
], CreateFinalNegotiationDto.prototype, "minutesOfMeeting", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 332,
        description: "Policy placed type (1=Single, 2=Multiple)",
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "Policy placed type is required" }),
    (0, class_validator_1.IsInt)({ message: "Policy placed type must be an integer" }),
    tslib_1.__metadata("design:type", Number)
], CreateFinalNegotiationDto.prototype, "policyPlacedTypeLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 163,
        description: "Lead insurer ID (if multiple insurers)",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Lead insurer ID must be an integer" }),
    tslib_1.__metadata("design:type", Number)
], CreateFinalNegotiationDto.prototype, "leadInsurerId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 338,
        description: "Only lead pays commission",
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "Only lead pays commission is required" }),
    (0, class_validator_1.IsInt)({ message: "Only lead pays commission must be a number" }),
    tslib_1.__metadata("design:type", Number)
], CreateFinalNegotiationDto.prototype, "onlyLeadPaysCommissionLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 1, description: "Finalized quote ID" }),
    (0, class_validator_1.IsNotEmpty)({ message: "Finalized quote ID is required" }),
    (0, class_validator_1.IsInt)({ message: "Finalized quote ID must be an integer" }),
    tslib_1.__metadata("design:type", Number)
], CreateFinalNegotiationDto.prototype, "finalisedQuoteId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 340,
        description: "Would change quote values?",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Would change quote values must be a integer" }),
    tslib_1.__metadata("design:type", Number)
], CreateFinalNegotiationDto.prototype, "wouldChangeQuoteValuesLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "Good cooperation.", description: "Other comments" }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Other comments must be a string" }),
    tslib_1.__metadata("design:type", String)
], CreateFinalNegotiationDto.prototype, "otherComments", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "Increased deductible by $500.",
        description: "Variations from QCR",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Variations must be a string" }),
    tslib_1.__metadata("design:type", String)
], CreateFinalNegotiationDto.prototype, "variations", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 334,
        description: "Service Level Agreement Days LID",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Service Level Agreement Days LID must be an integer" }),
    tslib_1.__metadata("design:type", Number)
], CreateFinalNegotiationDto.prototype, "serviceLevelAgreementDaysLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 35, description: "Document ID" }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Document ID must be an integer" }),
    tslib_1.__metadata("design:type", Number)
], CreateFinalNegotiationDto.prototype, "documentId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        type: [create_insurer_participants_dto_1.CreateInsurerParticipantDto],
        description: "List of insurer shares",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => create_insurer_participants_dto_1.CreateInsurerParticipantDto),
    tslib_1.__metadata("design:type", Array)
], CreateFinalNegotiationDto.prototype, "insurerShares", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        type: [create_final_negotiation_participants_dto_1.CreateFinalNegotiationParticipantDto],
        description: "List of participants",
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "Participants are required" }),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => create_final_negotiation_participants_dto_1.CreateFinalNegotiationParticipantDto),
    tslib_1.__metadata("design:type", Array)
], CreateFinalNegotiationDto.prototype, "participants", void 0);
